export class IdentificationConstant {
  static readonly IDENTIFICATION: string = "IDENTIFICATION";
  static readonly IDENTIFICATIONTYPE: string = "identificationType";
  static readonly DEFAULT_COUNTRY: string = "US";
}
